/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintPropostaCartaDebitoIntCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Parametri passati dalla rotta ndg + id prodotto
     * Necessari per la creazione della pratica
     */
    this.ndg;

    /**
     * Id del prodotto recuperato dalla path
     */
    this.idProdotto;

    /**
     * Id del target market recuperato dalla path
     */
    this.idTargetMarket;

    /**
     * Parametro passato dalla rotta con solo id pratica
     */
    this.idPratica;

    /**
     * Tabs di primo livello
     */
    this.TAB_LIST_MACRO = [];

    /**
     * Tabs di secondo livello
     */
    this.TAB_LIST_MICRO = {};

    /**
     * Tab attivo
     */
    this.currentTabMacro = {};

    /**
     * Sottotab attivo
     */
    this.currentTabMicro = {};

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * ===== GESTIONE BOTTONIERA A PIÉ DI PAGINA =====
     */

    /**
     * Pulsante annullamento pratica
     * Lancia la chiamata di annullamento
     */
    this.annullaPratica = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Aperta modale per richiesta annullamento sulla pratica ID ' + self.idPratica
      );

      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'cdintPropostaCartaDebitoInt/cdintModalAnnulla/cdintModalAnnulla.html',
          controller: 'cdintModalAnnullaController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(
          function (res) {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta annullamento con operazione completata per la pratica ID ' + self.idPratica
            );

            self.$state.go('schedaCliente', {
              ndg: self.ndg,
              idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
            });
          },
          function () {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta annullamento senza esecuzione richiesta per la pratica ID ' + self.idPratica
            );
          }
        );
    };

    /**
     * Pulsante annullamento pratica
     * Lancia la chiamata di annullamento
     */
    this.rifiutaPratica = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Aperta modale per richiesta rifiuta sulla pratica ID ' + self.idPratica
      );

      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'cdintPropostaCartaDebitoInt/cdintModalRifiuta/cdintModalRifiuta.html',
          controller: 'cdintModalRifiutaController',
          controllerAs: 'modalRifiutaCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(
          function (res) {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta rifiuto con operazione completata per la pratica ID ' + self.idPratica
            );

            self.$state.go('schedaCliente', {
              ndg: self.ndg,
              idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
            });
          },
          function () {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta rifiuto senza esecuzione richiesta per la pratica ID ' + self.idPratica
            );
          }
        );
    };

    //        /**
    //         * Pulsante rifiuta pratica
    //         * Lancia la chiamata di rifiuta
    //         */
    //        this.rifiutaPratica = function () {
    //          self.spinner.showSpinner++;
    //
    //          self.loggerSrvc.log(
    //            'CdintPropostaCartaDebitoIntCtrl',
    //            self.loggerSrvc.INFO,
    //            'Avvio rifiuto per la pratica ID ' + self.idPratica
    //          );
    //
    //          self.propostaCartaDebitoIntSrvc
    //            .promiseRifiutaPratica(
    //              self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
    //                ? self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
    //                : self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica,
    //              self.note
    //            )
    //            .then(
    //              function (response) {
    //                if (self.messaggiFctr.processaResponse(response)) {
    //                  return;
    //                }
    //
    //                self.loggerSrvc.log(
    //                  'CdintPropostaCartaDebitoIntCtrl',
    //                  self.loggerSrvc.INFO,
    //                  'Rifiuto completato per la pratica ID ' + self.idPratica
    //                );
    //
    //                self.$state.go('schedaCliente', { ndg: self.ndg , idAnagrafica : self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica });
    //              },
    //              function (reason) {
    //                self.messaggiFctr.processaResponse(reason);
    //
    //                self.loggerSrvc.log(
    //                  'CdintPropostaCartaDebitoIntCtrl',
    //                  self.loggerSrvc.SEVERE,
    //                  'Errore annullamento per la pratica ID ' +
    //                    self.idPratica +
    //                    ': ' +
    //                    self.loggerSrvc.formattaMessaggio(reason)
    //                );
    //              }
    //            )
    //            .finally(function () {
    //              if (self.spinner.showSpinner > 0) {
    //                self.spinner.showSpinner--;
    //              }
    //            });
    //        };

    /**
     * Verifica se per il macro step indicato esistono i micro-step
     */
    this.microStepPresenti = function (codiceMacroStep) {
      return self.TAB_LIST_MICRO[codiceMacroStep] && self.TAB_LIST_MICRO[codiceMacroStep].length > 0;
    };

    /**
     * Navigazione verso lo step precedente
     */
    this.indietro = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Arretramento di step per la pratica ID ' + self.idPratica
      );

      var stepIndex = self.TAB_LIST_MACRO.indexOf(self.currentTabMacro);
      var substepIndex = 0;

      if (self.microStepPresenti(self.currentTabMacro.step)) {
        substepIndex = self.TAB_LIST_MICRO[self.currentTabMacro.step].indexOf(self.currentTabMicro);
      }

      if (stepIndex === 0 && substepIndex === 0) {
        self.loggerSrvc.log(
          'CdintPropostaCartaDebitoIntCtrl',
          self.loggerSrvc.SEVERE,
          'Errore arretramento di step per la pratica ID ' +
            self.idPratica +
            ', tentativo di arretrare ad uno step con indice negativo'
        );

        return;
      }

      // Reimposto le funzioni di abilitazione della pulsantiera prima di passare di step
      // Lo step riassegnerà i propri nell'inizializzazione
      self.resetAbilitazioni();

      // Se ho indice substep > 0 ho sicuramente un micro-tab precedente ed indietreggio su quello
      // Altrimenti vado al macro-tab precedente, dove verifico se ho micro-tab
      if (substepIndex > 0) {
        self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][substepIndex - 1];
      } else {
        self.currentTabMicro = null;
        self.currentTabMacro = self.TAB_LIST_MACRO[stepIndex - 1];

        if (self.microStepPresenti(self.currentTabMacro.step)) {
          var lastIndex = self.TAB_LIST_MICRO[self.currentTabMacro.step].length - 1;
          self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][lastIndex];
        }
      }

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Arretramento di step completato per la pratica ID ' +
          self.idPratica +
          ': step ' +
          self.currentTabMacro.title +
          (self.currentTabMicro ? ' / ' + self.currentTabMicro.title : '')
      );
    };

    /**
     * Richiamato nelle funzioni salva e prosegui, lancia la chiamata abbinata allo stato e step pratica
     * e, se specificato, applica il flag per il solo salvataggio
     */
    this.eseguiSalvataggioStep = function (prosegui) {
      var stato = null;
      var step = null;

      // Recupero la prima combinazione, poiché la chiamate per completare ogni tab sono le solite
      if (self.currentTabMicro) {
        stato = self.currentTabMicro.statoPratica[0].stato;
        step = self.currentTabMicro.statoPratica[0].step;
      } else {
        stato = self.currentTabMacro.statoPratica[0].stato;
        step = self.currentTabMacro.statoPratica[0].step;
      }

      switch (stato) {
        case CONSTANTS.STATO_PRATICA.IN_CORSO:
        case CONSTANTS.STATO_PRATICA.DAREVISIONARE:
          // A seconda della specializzazione le chiamate da eseguire sono diverse
          switch (self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione) {
            case CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
            case CONSTANTS.SPECIALIZZAZIONI.CONSUMER:
              switch (step) {
                case 1:
                  self.checkIbanAndConfermaProdotto(prosegui, true);
                  //self.confermaProdotto(prosegui, true);
                  break;
                case 2:
                  self.confermaDatiAggiuntivi(
                    prosegui,
                    self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.CONSUMER
                      ? 2
                      : 1
                  );
                  break;
                case 3:
                  // nel caso della consumer faccio salvataggio questionario.
                  if (
                    self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.CONSUMER
                  ) {
                    self.confermaQuestionari(prosegui);
                  } else self.confermaDatiAggiuntivi(prosegui, 2);
                  break;
                case 4:
                  self.confermaQuestionari(prosegui);
                  break;
              }
              break;
            default:
              switch (step) {
                case 1:
                  self.confermaProdotto(prosegui, false);
                  break;
                case 2:
                  // rivedere per aml
                  self.confermaDatiAml(prosegui, null);
                  break;
                case 3:
                  self.confermaQuestionari(prosegui);
                  break;
              }
              break;
          }
          break;
      }
    };

    /**
     * Salvataggio dello stato della pratica
     */
    this.salva = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Salvataggio della pratica ID ' +
          self.idPratica +
          ': stato attuale ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.stato
      );

      self.eseguiSalvataggioStep(false);
    };

    /**
     * Proseguimento allo step successivo della pratica
     * O, se ci troviamo all'ultimo step, completamento
     */
    this.avanza = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avanzamento di step per la pratica ID ' +
          self.idPratica +
          ': stato attuale ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.stato
      );

      self.eseguiSalvataggioStep(true);
    };

    this.recuperaContoCorrente = function () {
      if (self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT) {
        self.spinner.showSpinner++;

        self.propostaCartaDebitoIntSrvc
          .promiseDettaglioContoCorrente(self.idPratica)
          .then(function (response) {
            // Anagrafica
            if (response && response.data.result) {
              // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
              // dei dati mancanti nell'anagrafica. QUindi imposto il flag è disabilito il bottone
              // per proseguire
              self.propostaCartaDebitoIntSrvc.datiPratica.iban = response.data.result.item.iban;
            }
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    this.confermaProdottoEsistente = function (prosegui, inviaDatiPG) {
      //Controllo che la pratica sia esistente
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        '[confermaProdottoEsistente] Conferma prodotto per la pratica ID ' + self.idPratica + ' self.idProdotto ' + self.idProdotto 
      );

      self.spinner.showSpinner++;

      // inserire nei dati aggiuntivi anche il prodotto selezionato.
      if (
        !inviaDatiPG &&
        self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT
      ) {
        self.idProdotto = self.propostaCartaDebitoIntSrvc.datiPratica.prodotto.idProdottoCPT;
        self.loggerSrvc.log(
	       'CdintPropostaCartaDebitoIntCtrl',
	       self.loggerSrvc.INFO,
	       '[confermaProdottoEsistente] Se sono LIGHT Conferma prodotto per la pratica ID ' + self.idPratica + ' self.idProdotto ' + self.idProdotto 
	    );
      }

      if(self.propostaCartaDebitoIntSrvc.datiAggiuntivi && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione && 
    		  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via){
    	  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via = self.propostaCartaDebitoIntSrvc.checkComma(self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via.toUpperCase());
      }
      
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        '[confermaProdottoEsistente] Dati inviati: idPratica ' + self.idPratica + '  e idProdotto ' + self.idProdotto 
      );
      return self.propostaCartaDebitoIntSrvc
        .promiseDefinizioneProdotto(
          self.idPratica,
          self.idProdotto,
          inviaDatiPG
            ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi,
          prosegui
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Conferma prodotto completata per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
            // Se tutto è andato a buon fine, ridirigo sulla rotta con id pratica
            self.propostaCartaDebitoIntSrvc.isRedirecting = true;
            self.$state.go(
              'cdint-proposta-carta-debito-int-pratica',
              {
                idPratica: self.idPratica
              },
              { reload: true }
            );
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma prodotto per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione eseguita dal prosegui del primo step, conferma il prodotto abbinato alla pratica
     */
    this.confermaProdotto = function (prosegui, inviaDatiPG) {
      if (self.propostaCartaDebitoIntSrvc.datiPratica.idPratica) {
        self.confermaProdottoEsistente(prosegui, inviaDatiPG);
      } else {
        self.creaPratica(prosegui, inviaDatiPG);
      }
    };

    this.checkIbanAndConfermaProdotto = function (prosegui, inviaDatiPG) {
      self.spinner.showSpinner++;

      self.propostaCartaDebitoIntSrvc
        .promiseCheckIbanAndConfermaProdotto(self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.confermaProdotto(prosegui, inviaDatiPG);
          },

          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore checkIbanAndConfermaProdotto' + self.loggerSrvc.formattaMessaggio(reason)
            );
            return;
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione che verifica se il tab specificato è abilitato per lo stato/step indicati
     * Step può essere null, in quel caso sarà verificato solo lo stato
     */
    this.tabContieneStatoStep = function (tab, stati, step) {
      if (!(tab && tab.statoPratica)) {
        return false;
      }

      if (!(stati && stati.length > 0)) {
        return false;
      }

      for (var i = 0; i < tab.statoPratica.length; i++) {
        if (stati.indexOf(tab.statoPratica[i].stato) > -1 && (!step || tab.statoPratica[i].step === step)) {
          return true;
        }
      }

      return false;
    };

    this.confermaDatiAml = function (prosegui, sottostep) {
      if (prosegui) {
        self.spinner.showSpinner++;
        self.propostaCartaDebitoIntSrvc
          .proseguiAml()
          .then(
            function (response) {
              // richiamo in cascata il cartadebitoint-mf per salvataggio step.
              if (response.isLastAfter) {
                // chiamo lo step di prosegui.

                // Recupero dal service, ma per default è nominativa
                self.callPromiseDatiAml(prosegui, {
                  tipoCarta:
                    self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
                    self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta
                      ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta
                      : 'I1',
                  idPratica: self.idPratica
                });
              }
            },

            function (reason) {
              self.messaggiFctr.processaResponse(reason);

              self.loggerSrvc.log(
                'CdintPropostaCartaDebitoIntCtrl',
                self.loggerSrvc.SEVERE,
                'Errore conferma dati aggiuntivi per la pratica ID ' +
                  self.idPratica +
                  ': ' +
                  self.loggerSrvc.formattaMessaggio(reason)
              );
            }
          )
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      } else {
        self.spinner.showSpinner++;
        // salvataggio
        self.propostaCartaDebitoIntSrvc
          .salvaAml()
          .then()
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    /**
     * Funzione eseguita dal prosegui del secondo step, conferma i dati aggiuntivi
     * Nel caso di specializzazione Smallbusiness (SDI) si passa anche il sotto-step per identificare il passaggio da salvare
     */
    this.confermaDatiAggiuntivi = function (prosegui, sottostep) {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Conferma dati aggiuntivi per la pratica ID ' + self.idPratica
      );

      // A seconda dello step in cui mi trovo, invio dati diversi al servizio
      // Sottostep null: specializzazione light
      // Sottostep 1: specializzazione SDI, dati persona giuridica
      // Sottostep 2: specializzazione SDI, dati persona fisica
      var datiAggiuntivi = null;
      switch (sottostep) {
        case null:
        case undefined:
          datiAggiuntivi = self.propostaCartaDebitoIntSrvc.datiAggiuntivi;
          break;
        case 1:
          datiAggiuntivi = self.propostaCartaDebitoIntSrvc.datiAggiuntiviPg;
          break;
        case 2:
          // check sulla parte di indirizzo residenza o spedizione
          if (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf) {
            this.propostaCartaDebitoIntSrvc.copiaIndirizzoResidenzaInSpedizione();
          }
          datiAggiuntivi = self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf
            ? self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi;
          break;
      }

      if (!datiAggiuntivi) {
        self.loggerSrvc.log(
          'CdintPropostaCartaDebitoIntCtrl',
          self.loggerSrvc.ERROR,
          'Chiamata di salvataggio dati aggiuntivi non validi per la pratica ' +
            self.idPratica +
            '. Step specificato: ' +
            sottostep
        );
        return;
      }

      self.callPromiseDatiAggiuntivi(prosegui, datiAggiuntivi, sottostep);
    };

    this.callPromiseDatiAggiuntivi = function (prosegui, datiAggiuntivi, sottostep) {
      self.spinner.showSpinner++;
      console.log(
        '[callPromiseDatiAggiuntivi] idPratica: ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica +
          ' idPratica recuperata dai dati aggiuntivi: ' +
          datiAggiuntivi.idPratica
      );
      
      if(datiAggiuntivi && datiAggiuntivi.indirizzoSpedizione && datiAggiuntivi.indirizzoSpedizione.via){
    	  datiAggiuntivi.indirizzoSpedizione.via = self.propostaCartaDebitoIntSrvc.checkComma(datiAggiuntivi.indirizzoSpedizione.via.toUpperCase());
      }
      
      return self.propostaCartaDebitoIntSrvc
        .promiseDatiAggiuntivi(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica,
          datiAggiuntivi,
          prosegui,
          sottostep
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Conferma dati aggiuntivi completata per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aggiuntivi per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.callPromiseDatiAml = function (prosegui, datiAggiuntivi) {
      self.spinner.showSpinner++;

      return self.propostaCartaDebitoIntSrvc
        .promiseDatiAml(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica, datiAggiuntivi, prosegui)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Conferma dati aml completata per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aml per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione eseguita dal prosegui del terzo step, questionari. Salva il questionario compilato
     */
    this.confermaQuestionari = function (prosegui) {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Salvataggio questionari per la pratica ID ' + self.idPratica
      );

      self.spinner.showSpinner++;

      return self.propostaCartaDebitoIntSrvc
        .promiseSaveQuestionari(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica,
          self.propostaCartaDebitoIntSrvc.questionari,
          prosegui
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Salvataggio questionari completato per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            // recupero l'iban se non impostato per qualche movito solo per la light.
            if (
              self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT &&
              !self.propostaCartaDebitoIntSrvc.datiPratica.iban
            )
              self.recuperaContoCorrente();

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore salvataggio questionari per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.isPraticaPresentata = function () {
      return self.propostaCartaDebitoIntSrvc.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA;
    };

    /**
     * Funzione eseguita dal prosegui dell'ultimo step, richiamata ricorsivamente finché la pratica
     * non è in uno stato valido
     */
    this.completaPratica = function () {
      //controllo se è un prospetto persona fisica di Banca Cloud
      self.spinner.showSpinner++;
      return self.propostaCartaDebitoIntSrvc
        .promiseProspettoPersonaFisica(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Prospetto persona fisica per la pratica ID ' + self.idPratica
            );

            self.datiProspetto = response.data.result;

            if (!self.datiProspetto) {
              self.completaPraticaDefinitivo();
            } else {
              self.controllaAccettazione();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aggiuntivi per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.controllaAccettazione = function () {
      self.spinner.showSpinner++;
      return self.propostaCartaDebitoIntSrvc
        .promiseAccettazionePratica(self.datiProspetto)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Controlla Accettazione per la pratica ID ' + self.idPratica
            );

            self.completaPraticaDefinitivo();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aggiuntivi per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.completaPraticaDefinitivo = function () {
      self.spinner.showSpinner++;
      return self.propostaCartaDebitoIntSrvc
        .promiseCompletaPratica(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
              if (self.spinner.showSpinner > 0) {
                self.spinner.showSpinner--;
              }
              return;
            }
            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            // Dopo che si è caricato i documenti (stato pratica CONSOLIDATA 3/6) si effettua una prima chiamata al completa
            // che porta la pratica in PRESENTATA 1, dopodichè si esce dal wizard e la pratica viene trasferita in un'altra
            // coda lavoro (del backoffice) che si occupa di fare un'altra serie di chiamate al completa che portano la pratica
            // in PRESENTATA 3 e infine in ACCETTATA o DAREVISIONARE. UNa volta che la pratica è in uno di questi stati
            // o è conclusa (ACCETTATA) oppure (DAREVISIONARE) si procede col modificare i dati e riportare quindi la pratica in INCORSO 1
            // una volta cliccato sul "prosegui" presente nella pagina di definizione prodotto.
            switch (self.propostaCartaDebitoIntSrvc.datiPratica.stato) {
              case CONSTANTS.STATO_PRATICA.ACCETTATA:
              case CONSTANTS.STATO_PRATICA.DAREVISIONARE:
                // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                if (self.spinner.showSpinner > 0) {
                  self.spinner.showSpinner--;
                }
                self.$state.go('schedaCliente', {
                  ndg: self.ndg,
                  idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
                });
                break;
              case CONSTANTS.STATO_PRATICA.PRESENTATA:
                // Ho portato la pratica da CONSOLIDATA 3 a PRESENTATA 1 quindi mi fermo, esco dal wizard
                // e la pratica viene trasferita in un'altra coda lavoro
                if (self.propostaCartaDebitoIntSrvc.datiPratica.step === 1) {
                  self.loggerSrvc.log(
                    'CdintPropostaCartaDebitoIntCtrl',
                    self.loggerSrvc.INFO,
                    'Passaggio da INCORSO a PRESENTATA per la pratica con id ' + self.idPratica
                  );
                  // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                  if (self.spinner.showSpinner > 0) {
                    self.spinner.showSpinner--;
                  }
                  self.$state.go('schedaCliente', {
                    ndg: self.ndg,
                    idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
                  });
                } else {
                  // Se la pratica non ha raggiunto stato ACCETTATA o DAREVISIONARE, continuo a richiamare il servizio
                  // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                  if (self.spinner.showSpinner > 0) {
                    self.spinner.showSpinner--;
                  }
                  self.completaPraticaDefinitivo();
                }
                break;
              default:
                // Se la pratica non ha raggiunto stato ACCETTATA o DAREVISIONARE, continuo a richiamare il servizio
                // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                if (self.spinner.showSpinner > 0) {
                  self.spinner.showSpinner--;
                }
                self.completaPraticaDefinitivo();
                break;
            }
          },
          function (reason) {
            // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          // In teoria non dovrebbe mai scendere sotto lo 0, tuttavia, essendo una chiamata asincrona e ricorsiva, è
          // stato aggiunto anche questo controllo per impedire a spinner di essere < 0
          if (self.showSpinner < 0) {
            self.spinner.showSpinner = 0;
          }
        });
    };

    /**
     * Reimposta le funzioni di abilitazione e visualizzazione dei pulsanti a pié di pagina
     */
    this.resetAbilitazioni = function () {
      self.propostaCartaDebitoIntSrvc.indietroAbilitato = self.propostaCartaDebitoIntSrvc.defaultIndietroAbilitato;
      self.propostaCartaDebitoIntSrvc.salvaVisibile = self.propostaCartaDebitoIntSrvc.defaultSalvaVisibile;
      self.propostaCartaDebitoIntSrvc.salvaAbilitato = self.propostaCartaDebitoIntSrvc.defaultSalvaAbilitato;
      self.propostaCartaDebitoIntSrvc.proseguiAbilitato = self.propostaCartaDebitoIntSrvc.defaultProseguiAbilitato;
    };

    /**
     * Torna ad inizio pratica
     */
    this.inizioPratica = function () {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        "Torno all'inizio del processo per la pratica ID " + self.idPratica
      );

      if (self.currentTabMacro !== self.TAB_LIST_MACRO[0]) {
        self.currentTabMacro = self.TAB_LIST_MACRO[0];
      } else {
        self.init();
      }
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function (tab) {
      if (!self.propostaCartaDebitoIntSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Verifico se il tab ha sotto-tab
      if (self.TAB_LIST_MICRO[self.currentTabMacro.step] && self.TAB_LIST_MICRO[self.currentTabMacro.step].length > 0) {
        self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][0];
      } else {
        self.currentTabMicro = null;
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function (currentTabIndex) {
      // Pratica navigabile
      if (self.propostaCartaDebitoIntSrvc.isPraticaNavigabile() === true) {
        if (currentTabIndex === self.currentTabMicro.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (currentTabIndex < self.currentTabMicro.index) {
        return 'ab-step-tabs';
      }

      if (currentTabIndex === self.currentTabMicro.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function (currentTabIndex) {
      if (self.propostaCartaDebitoIntSrvc.isPraticaNavigabile() === true) {
        return 'step read';
      }

      if (currentTabIndex < self.currentTabMicro.index) {
        return 'step success';
      }

      return 'step';
    };

    /**
     * @ngdoc method
     * @name microTabClicked
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
     * @description Apre il micro-tab selezionato
     * @param {Object} tab - il micro-tab selezionato
     */
    this.microTabClicked = function (tab) {
      if (self.propostaCartaDebitoIntSrvc.isPraticaNavigabile() !== true) {
        return;
      }

      self.currentTabMicro = tab;
    };

    /**
     * In base allo step definito nel tab, recupera l'URL del template da visualizzare
     */
    this.getStepUrl = function (step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'SPEDIZIONE':
          return 'spedizione.tmpl.html';
        case 'DATIAGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        case 'DATIAML':
          return 'datiAml.tmpl.html';
        case 'DATIAGGIUNTIVIPG':
          return 'datiAggiuntiviPG.tmpl.html';
        case 'DATIAGGIUNTIVIPF':
          return 'datiAggiuntiviPF.tmpl.html';
        case 'QUESTIONARI':
          return 'questionari.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return null;
      }
    };

    /**
     * Funzione che dopo il recupero dei tab o dopo un cambio stato evidenzia il tab attivo
     * in base allo stato della pratica
     */
    this.attivaTabPerStatoPratica = function () {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Attivazione tab per pratica ID ' +
          self.idPratica +
          ': Stato ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.stato +
          ', Step ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.step
      );

      if (
        self.propostaCartaDebitoIntSrvc.datiPratica &&
        self.propostaCartaDebitoIntSrvc.datiPratica.stato &&
        self.propostaCartaDebitoIntSrvc.datiPratica.step
      ) {
        // Se la pratica è in stato di ACCETTATA apro direttamente
        // la prima tab e primo step visto che il wizard è navigabile
        if (self.propostaCartaDebitoIntSrvc.datiPratica.stato === CONSTANTS.STATO_PRATICA.ACCETTATA) {
          self.currentTabMacro = self.TAB_LIST_MACRO[0];
          self.currentTabMicro = self.TAB_LIST_MICRO[0];
          return;
        }

        // Nel caso di pratica consolidata devo valutare solamente lo stato
        // Negli altri casi tutto il resto
        for (var i = 0; i < self.TAB_LIST_MACRO.length; i++) {
          var macroTab = self.TAB_LIST_MACRO[i];
          // Verifico se ho dei sotto-tab
          // In caso positivo imposto sia il macro-tab che il micro-tab
          if (!macroTab.statoPratica && self.TAB_LIST_MICRO[macroTab.step]) {
            for (var j = 0; j < self.TAB_LIST_MICRO[macroTab.step].length; j++) {
              var microTab = self.TAB_LIST_MICRO[macroTab.step][j];
              if (
                self.tabContieneStatoStep(
                  microTab,
                  [self.propostaCartaDebitoIntSrvc.datiPratica.stato],
                  self.propostaCartaDebitoIntSrvc.datiPratica.step
                )
              ) {
                self.currentTabMacro = macroTab;
                self.currentTabMicro = microTab;

                self.loggerSrvc.log(
                  'CdintPropostaCartaDebitoIntCtrl',
                  self.loggerSrvc.INFO,
                  'Apertura tab ' +
                    self.currentTabMacro.title +
                    '/' +
                    self.currentTabMicro.title +
                    ' per pratica ID ' +
                    self.idPratica
                );
                return;
              }
            }

            continue;
          }

          // Altrimenti solo il macro-tab
          if (
            self.tabContieneStatoStep(
              macroTab,
              [self.propostaCartaDebitoIntSrvc.datiPratica.stato],
              self.propostaCartaDebitoIntSrvc.datiPratica.step
            )
          ) {
            self.currentTabMacro = macroTab;
            self.currentTabMicro = null;

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Apertura tab ' + self.currentTabMacro.title + ' per pratica ID ' + self.idPratica
            );

            return;
          }
        }
      }

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Apertura tab di default pratica ID ' + self.idPratica
      );

      self.currentTabMacro = self.TAB_LIST_MACRO[0];
      //EMonetica-630
      //Se lo stato della pratica è ANNULLATA o RIFIUTATA forzo il click al primo step
      if (
        self.propostaCartaDebitoIntSrvc.datiPratica.stato == CONSTANTS.STATO_PRATICA.ANNULLATA ||
        self.propostaCartaDebitoIntSrvc.datiPratica.stato == CONSTANTS.STATO_PRATICA.RIFIUTATA
      ) {
        self.macroTabClicked(self.currentTabMacro);
      }
    };

    /**
     * Funzione richiamata dopo il caricamento della pratica, recupera le tabs disponibili
     */
    this.recuperaTabs = function () {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Elaborazione tabs pratica ' + self.idPratica
      );

      var tabs = self.propostaCartaDebitoIntSrvc.generaTabs(self.propostaCartaDebitoIntSrvc.datiPratica);

      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      // Costruzione tabs
      var tabData = null;
      var subtabData = null;
      for (var i = 0; i < tabs.length; i++) {
        tabData = tabs[i];
        subtabData = null;

        self.TAB_LIST_MACRO.push({
          index: i,
          step: tabData.step,
          title: tabData.posizione + ' ' + $scope.msg(tabData.label),
          url: self.getStepUrl(tabData.step),
          statoPratica: tabData.statoPratica
        });

        // Costruzione sotto-tabs, se presenti
        if (tabData.sottoStep && tabData.sottoStep.length > 0) {
          self.TAB_LIST_MICRO[tabData.step] = [];

          for (var j = 0; j < tabData.sottoStep.length; j++) {
            subtabData = tabData.sottoStep[j];

            self.TAB_LIST_MICRO[tabData.step].push({
              index: j,
              step: subtabData.step,
              title: tabData.posizione + '.' + subtabData.posizione + ' ' + $scope.msg(subtabData.label),
              url: self.getStepUrl(subtabData.step),
              statoPratica: subtabData.statoPratica
            });
          }
        }
      }

      self.attivaTabPerStatoPratica();
    };

    /**
     * Funzione richiamata in caso sia stato passato come parametro il solo id pratica
     * Recupera la pratica e mostra lo step corretto in base allo stato
     */
    this.recuperaPratica = function () {
      self.spinner.showSpinner++;
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Recupero della pratica ' + self.idPratica
      );

      self.propostaCartaDebitoIntSrvc
        .promiseDettaglioPratica(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            // response.data.result.specializzazione = self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS;

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Recuperata con successo pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            self.recuperaContoCorrente();

            // Controllo prodotto per Carta Debito Consumer
            self.propostaCartaDebitoIntSrvc.debitoConsumer = response.data.result.specializzazione;

            // Verifico se mi trovo sulla rotta con o senza NDG
            // Se non ho l'ndg, redirigo
            if (!self.$stateParams.ndg) {
              self.$state.go(
                'cdint-proposta-carta-debito-int-pratica-n',
                {
                  idPratica: self.idPratica,
                  ndg: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
                },
                { reload: true }
              );
              return;
            } else {
              self.ndg = self.$stateParams.ndg;
            }

            self.recuperaTabs();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il recupero della pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione richiamata in caso siano stati passati come parametri id prodotto ed ndg
     * Avvia la creazione della pratica e, in caso di esito positivo, redirige alla rotta
     * con solo id pratica
     */
    this.prendiDettaglioProdotto = function () {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Dettaglio Prodotto ' + self.idProdotto
      );

      self.propostaCartaDebitoIntSrvc
        .promiseDettaglioProdotto(self.ndg, self.idProdotto)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Dettaglio prodotto con ID ' + self.idProdotto
            );

            // Se tutto è andato a buon fine, ridirigo sulla rotta con id pratica
            self.recuperaTabs();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il dettaglio del prodotto ' +
                self.idProdotto +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione richiamata in caso siano stati passati come parametri id prodotto ed ndg
     * Avvia la creazione della pratica e, in caso di esito positivo, redirige alla rotta
     * con solo id pratica
     */
    this.creaPratica = function (prosegui, inviaDatiPG) {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Creazione nuova pratica per NDG ' + self.ndg + ' e Prodotto ' + self.idProdotto
      );

      console.log('Pre chiamata crea pratica ' + self.propostaCartaDebitoIntSrvc.idTargetMarket);

      self.propostaCartaDebitoIntSrvc
        .promiseCreaPratica(
          self.ndg,
          self.idProdotto,
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB
            ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.codiceBusta
            : null,
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban,
          self.propostaCartaDebitoIntSrvc.idTargetMarket ? self.propostaCartaDebitoIntSrvc.idTargetMarket : null,
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione ? self.propostaCartaDebitoIntSrvc.checkComma(self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via) : null,
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB && self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore : null,
          inviaDatiPG
                  ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB
                  : self.propostaCartaDebitoIntSrvc.datiAggiuntivi
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

//            self.loggerSrvc.log(
//              'CdintPropostaCartaDebitoIntCtrl',
//              self.loggerSrvc.INFO,
//              'Creata con successo la pratica con ID ' + self.idPratica
//            );
//
//            if (
//              self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
//              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica
//            ) {
//              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica = self.idPratica;
//            }
//
//            self.confermaProdottoEsistente(prosegui, inviaDatiPG);
            
        	self.idPratica = response.data.result.idPratica;
            self.loggerSrvc.log(
	            'CdintPropostaCartaDebitoIntCtrl',
	            self.loggerSrvc.INFO,
	            'Conferma prodotto completata per la pratica ID ' + self.idPratica
	          );
	
	          self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
	
	          if (prosegui) {
	            self.resetAbilitazioni();
	            self.attivaTabPerStatoPratica();
	          }
	          // Se tutto è andato a buon fine, ridirigo sulla rotta con id pratica
	          self.propostaCartaDebitoIntSrvc.isRedirecting = true;
	          self.$state.go(
	            'cdint-proposta-carta-debito-int-pratica',
	            {
	              idPratica: self.idPratica
	            },
	            { reload: true }
	          );
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante la creazione della per NDG ' +
                self.ndg +
                ' e Prodotto ' +
                self.idProdotto +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione per prendere in carico la pratica
     */
    this.prendiInCarico = function () {
      //controllo se è un prospetto persona fisica di Banca Cloud
      self.spinner.showSpinner++;
      self.propostaCartaDebitoIntSrvc
        .promisePrendiInCarico(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
              return false;
            };
            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
              return true;
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante la presa in carico della pratica  ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione per rilasciare la pratica
     */
    this.rilasciaPratica = function () {
      //controllo se è un prospetto persona fisica di Banca Cloud
      self.spinner.showSpinner++;
      self.propostaCartaDebitoIntSrvc
        .promiseRilasciaPratica(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
              return true;
            };
            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
              return false;
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante la presa in carico della pratica  ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      self.resetAbilitazioni();

      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        /**
         * Caso 1: rotta con NDG, id Prodotto e id TargetMarket
         * Creo la pratica partendo da questi dati e redirigo alla rotta con solo di Pratica
         */
        if (self.$stateParams.ndg && self.$stateParams.idProdotto) {
          self.ndg = self.$stateParams.ndg;
          self.idProdotto = self.$stateParams.idProdotto;
          self.propostaCartaDebitoIntSrvc.idTargetMarket = !!self.$stateParams.idTargetMarket
            ? self.$stateParams.idTargetMarket
            : null;
          self.propostaCartaDebitoIntSrvc.ndg = self.ndg;
          self.propostaCartaDebitoIntSrvc.idProdotto = self.idProdotto;
          self.prendiDettaglioProdotto();

          console.log(
            'self.propostaCartaDebitoIntSrvc.idTargetMarket' + self.propostaCartaDebitoIntSrvc.idTargetMarket
          );
          return;
        }

        /**
         * Caso 2: rotta con solo ID Pratica, carico i dati della pratica e mostro
         * il passaggio in base allo stato della pratica stessa
         */
        if (self.$stateParams.idPratica) {
          self.idPratica = self.$stateParams.idPratica;
          self.recuperaPratica();
          return;
        }

        /**
         * Caso di nessun parametro passato
         */
        self.messaggiFctr.addMessage({
          type: 'E',
          message: $scope.msg('label.errors.parametersNotReceived')
        });
        self.loggerSrvc.log(
          'CdintPropostaCartaDebitoIntCtrl',
          self.loggerSrvc.SEVERE,
          $scope.msg('label.errors.parametersNotReceived')
        );
      });
    };

    self.init();
  };

  CdintPropostaCartaDebitoIntCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cdintPropostaCartaDebitoInt/cdintPropostaCartaDebitoInt.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintPropostaCartaDebitoIntComponent = {
    controller: CdintPropostaCartaDebitoIntCtrl,
    controllerAs: 'cdintPropostaCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.cartadebitoint.wa')
    .component('cdintPropostaCartaDebitoInt', CdintPropostaCartaDebitoIntComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintPropostaCartaDebitoInt.cmpt.js
// module id = 12
// module chunks = 0